import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    @media (max-width: 1080px) {
      font-size: 93.75%;
    }

    @media (max-width: 720px) {
      font-size: 87.5%;
    }
    background-color: ${props => props.theme.background.primary};
  }

  body {
    -webkit-font-smoothing: antialiased;

    @media (max-width: 768px) {
      overflow: hidden;
    }
  }

  body, input, textarea, button {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    background-color: ${props => props.theme.background.primary};
  }

  h1 {
    font-size: 3rem;
    line-height: 3.25rem;
  }

  h2 {
    font-size: 2rem;
    line-height: 2.75rem;
  }

  h3 {
    font-size: 1.5rem;
    line-height: 2.375rem;
  }

  h4 {
    font-size: 1.25rem;
    line-height: 2rem;
  }

  h5 {
    font-size: 1rem;
    line-height: 1.75rem;
  }

  p, span, label {
    margin: 0;
    padding: 0;
  }

  input {
    font-size: 0.875rem;
    line-height: 1.225rem;
  }

  button {
    cursor: pointer;
  }

  [disabled] {
    opacity: 0.6;
    cursor: not-allowed;
  }

  /* WhatsApp-style scrollbar - Global */
  * {
    scrollbar-width: thin;
    scrollbar-color: ${props => props.theme.colors.borderColorSecondary} transparent;
  }

  *::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  *::-webkit-scrollbar-track {
    background: transparent;
  }

  *::-webkit-scrollbar-thumb {
    background: ${props => props.theme.colors.borderColorSecondary};
    border-radius: 3px;
  }

  *::-webkit-scrollbar-thumb:hover {
    background: ${props => props.theme.colors.tertiary};
  }

  /* Selection color */
  ::selection {
    background: ${props => props.theme.colors.accentColor};
    color: #FFFFFF;
  }

  /* Message highlight on reply click */
  .highlighted {
    animation: highlightFlash 2s ease-out;
  }

  @keyframes highlightFlash {
    0%   { background-color: ${props => props.theme.colors.accentColor}33; }
    50%  { background-color: ${props => props.theme.colors.accentColor}66; }
    100% { background-color: transparent; }
  }

  /* Toast theme overrides */
  .Toastify__toast {
    background-color: ${props => props.theme.background.secondary} !important;
    color: ${props => props.theme.colors.primary} !important;
  }

  .Toastify__toast-body {
    color: ${props => props.theme.colors.primary} !important;
  }

  .Toastify__close-button {
    color: ${props => props.theme.colors.primary} !important;
    opacity: 0.7;
  }
`
